export const JOB_DETAILS = "JOB_DETAILS";
export const SESSION_PARTICIPANTS = "SESSION_PARTICIPANTS";
export const PARTICIPANTS_LIST = "PARTICIPANTS_LIST";
export const ROLE_DESCRIPTORS = "ROLE_DESCRIPTORS";
export const ROLE_DESCRIPTORS_BY_SESSION_ID = "ROLE_DESCRIPTORS_BY_SESSION_ID";
export const SESSION_FLOWER_DATA = "SESSION_FLOWER_DATA";
export const PETALS_SESSION_DATA = "PETALS_SESSION_DATA";
